import { useRef } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useTQC2070_R01Store } from "./Store_TQC2070_R01";
import { AgGridReact } from "ag-grid-react";
import { Content_TQC2070_R01 } from "./Content_TQC2070_R01";
import { TQC2070_R01Dto } from "./Dto_TQC2070_R01";
import { SearchSection_TQC2070_R01 } from "./SearchSection_TQC2070_R01";
import { Table_TQC2070_R01 } from "./Table_TQC2070_R01";
import { Chart_TQC2070_R01 } from "./Chart_TQC2070_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";

export const Container_TQC2070_R01 = () => {
	const { initData, TQC2070_R01List } = useTQC2070_R01Store();

	const gridRef = useRef<AgGridReact<TQC2070_R01Dto>>(null);

	const {
		clickable, setClickable,
		fetchData,
		initContainerData,
		handleDeleteClick,
		handleInsertClick,
		handleExcelClick,
		handleSaveClick,
		handlePdfZincClick,
		handlePdfNaohClick,
	} = Content_TQC2070_R01({
		gridRef,
	});

	// 리사이저 설정 (테이블과 차트 분할)
	const RESIZER = {
		code: 'TQC2070_R01',
		type: 'width',
		storageKey: 'TQC2070_R01-split-width',
		min: 20,
		max: 80,
		default: 50
	} as const;

	const containerRef = useRef<HTMLDivElement>(null);
	const chartRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const {
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef: chartRef
	});

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC2070_R01 
				onEnterKeyDown={fetchData}
				onPdfZincClick={handlePdfZincClick}
				onPdfNaohClick={handlePdfNaohClick}
			/>
			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				{/* 테이블 영역 (왼쪽) */}
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_TQC2070_R01 
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						handleInsertClick={handleInsertClick}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				{/* 차트 영역 (오른쪽) */}
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={chartRef}>
					<Chart_TQC2070_R01 data={TQC2070_R01List} />
				</div>
			</div>
			<Message />
		</div>
	);
};

